import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from "react-router-dom";
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import ArrowBackIosNewSharpIcon from '@mui/icons-material/ArrowBackIosNewSharp';
import Paper from '@mui/material/Paper';
import { visuallyHidden } from '@mui/utils';
import Divider from '@mui/material/Divider';
import styled from '@emotion/styled';
import Select from "react-select";
import { createNotification } from '../../../Config/NotificationToast';
import {
    FormGroup,
    Label,
} from "reactstrap";
import {
    stableSort,
    rowOptions,
    options,
    getComparator,
} from '../../../utils/Helper'
import * as routes from "../../../Router/RoutesURL";
import { useSelector, useDispatch } from 'react-redux';
import { viewPrograms, updateIsActiveStatus, getAnandaProgamLevels } from '../../../redux/actions/MasterDataAction/ProgramAction/programActions';
import './Programs.scss';
import { CircularProgress } from '@mui/material';
import { POSITIVE_NUMBER, tabKeys } from '../../../Config/Constant';

const MainHeading = styled(Typography)(({ theme }) => ({
    color: theme.palette.primary.main,
}))


const headCells = [
    {
        id: 'title',
        disablePadding: true,
        label: 'PROGRAM TITLE',
    },
    {
        id: 'level',
        disablePadding: false,
        label: 'LEVEL',
    },
    {
        id: 'duration',
        disablePadding: false,
        label: 'DURATION',
    },
    {
        id: 'usage',
        disablePadding: false,
        label: 'USAGE',
    },
    {
        id: 'created_on',
        disablePadding: false,
        label: 'CREATED ON',
    },
    {
        id: 'status',
        disablePadding: false,
        label: 'STATUS',
    },
    {
        id: 'action',
        disablePadding: false,
        label: 'ACTION',
        disableSorting: true

    },
];

const EnhancedTableHead = (props) => {
    const { order, orderBy, onRequestSort } =
        props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) =>
                (<TableCell
                    key={headCell.id}
                    align='left'
                    padding={headCell.disablePadding ? 'none' : 'normal'}
                    sortDirection={orderBy === headCell.id ? order : false}
                >
                    <TableSortLabel
                        active={orderBy === headCell.id  && !headCell.disableSorting}
                        direction={orderBy === headCell.id ? order : 'asc'}
                        onClick={createSortHandler(headCell.id)}
                        hideSortIcon={headCell.disableSorting}
                        disabled={headCell.disableSorting}
                    >
                        {headCell.label}
                        {orderBy === headCell.id ? (
                            <Box component="span" sx={visuallyHidden}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                        ) : null}
                    </TableSortLabel>
                </TableCell>)
                )}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const EnhancedTableToolbar = (props) => {
    const { setShowLoader, showLoader, activeTab } = props;
    const dispatch = useDispatch();
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchText, setSearchText] = useState(searchParams.get('filter_text') || '');
    const [maxDuration, setMaxDuration] = useState(searchParams.get('max_duration') || '');
    const [minDuration, setMinDuration] = useState(searchParams.get('min_duration') || '');
    const [levelData, setLevelData] = useState(searchParams.get('level') ? { label: searchParams.get('level'), value: searchParams.get('level') } : '');
    const programLevelsDat = useSelector(state => state?.programLevels?.programLevels);
    const rowsPerPageNos = searchParams.get('limit') || 10;

    const options = [
        { value: '', label: 'All' },
        { value: 'Comprehensive', label: 'Comprehensive' },
        { value: 'Foundation and Comprehensive', label: 'Foundation & Comprehensive' },
    ];

    useEffect(() => {
        if (activeTab == tabKeys.masterData.PROGRAMS) {
            setSearchText(searchParams.get('filter_text') || '');
            setMaxDuration(searchParams.get('max_duration') || '');
            setMinDuration(searchParams.get('min_duration') || '');
            const level = searchParams.get('level');
            setLevelData(level ? { label: level, value: level } : '');
        }
    }, [activeTab, searchParams]);

    const handleChangeLevel = (e) => {
        const newParams = new URLSearchParams(searchParams);
        if (e && e.value) {
            newParams.set('level', e.value);
        } else {
            newParams.delete('level');
        }
        newParams.set('page', 1);
        setSearchParams(newParams, { replace: true });

        setShowLoader(true)
        setLevelData(e)

        const sendRequest = {
            "pageNo": 1,
            "pageSize": rowsPerPageNos,
            "filter_text": searchText,
            "level": e.value,
            "min_duration": minDuration,
            "max_duration": maxDuration,
        };
        dispatch(viewPrograms(sendRequest));
    }

    const handleChangeSearch = (e) => {

        const newParams = new URLSearchParams(searchParams);
        if (e.target.value) {
            newParams.set('filter_text', e.target.value);
        } else {
            newParams.delete('filter_text');
        }
        newParams.set('page', 1);
        setSearchParams(newParams, { replace: true });

        setShowLoader(true)
        setSearchText(e.target.value)
        const sendRequest = {
            "pageNo": 1,
            "pageSize": rowsPerPageNos,
            "filter_text": e.target.value,
            "level": levelData.value,
            "min_duration": minDuration,
            "max_duration": maxDuration,
        };
        dispatch(viewPrograms(sendRequest));
    }

    const changeMinDuration = (e) => {
      let value=e.target.value;
      if (value !== "" && (!POSITIVE_NUMBER.test(value) || Number(value) < 0) ) {
        return;
      }
      if (value && maxDuration &&  maxDuration<Number(value)) {
        return;
      }

        const newParams = new URLSearchParams(searchParams);
        if (e.target.value) {
            newParams.set('min_duration', e.target.value);
        } else {
            newParams.delete('min_duration');
        }
        newParams.set('page', 1);
        newParams.set('max_duration', maxDuration);
        setSearchParams(newParams, { replace: true });

        setShowLoader(true)
        setMinDuration(e.target.value)

        const sendRequest = {
            "pageNo": 1,
            "pageSize": rowsPerPageNos,
            "filter_text": searchText,
            "level": levelData.value,
            "min_duration": e.target.value,
            "max_duration": maxDuration,
        };
        dispatch(viewPrograms(sendRequest));
    }

    const changeMaxDuration = (e) => {
      let value=e.target.value;
      if (value !== "" && (!POSITIVE_NUMBER.test(value) || Number(value) < 0)) {
        return;
      }
      setMaxDuration(value)
      if(Number(value)<Number(minDuration)){
        createNotification('warning', "Max value should be greater than min.")
        return
      }else{
        const newParams = new URLSearchParams(searchParams);
        if (e.target.value) {
            newParams.set('max_duration', e.target.value);
        } else {
            newParams.delete('max_duration');
        }
        newParams.set('page', 1);
        setSearchParams(newParams, { replace: true });

        setShowLoader(true)
        const sendRequest = {
            "pageNo": 1,
            "pageSize": rowsPerPageNos,
            "filter_text": searchText,
            "level": levelData.value,
            "min_duration": minDuration,
            "max_duration": e.target.value,
        };
        dispatch(viewPrograms(sendRequest));
      }

    }

    return (
        <div>
            <Toolbar sx={{
                pl: { sm: 2 },
                pt: { sm: 2 },
                pb: { sm: 2 },
                pr: { xs: 1, sm: 1 },

            }}
            >
                <div className='col-2 col-sm-2 col-md-2 col-lg-2 col-xl-2 col-xxl-3'>
                    <MainHeading
                        sx={{ flex: '1 1 100%', }}
                        variant="h6"
                        id="tableTitle"
                        component="div"
                    >
                        Program List
                    </MainHeading>
                </div>
                <div className='col-2 col-sm-2 col-md-2 col-lg-2 col-xl-10 col-xxl-9 LevelDiv'>
                    <FormGroup className="FormGroup has-float-label class-menu-dropdown ">
                        <Label>Level:</Label>
                        <Select
                            placeholder="Level"
                            className="react-select"
                            classNamePrefix="react-select"
                            value={levelData}
                            options={[
                              {label: "All", value: ''},
                              ...(programLevelsDat ? programLevelsDat.map(item => ({ label: item.level, value: item.level })) : [])
                            ]}
                            onChange={handleChangeLevel}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary25: '#F5F5F5',
                                    primary: '#74613C',
                                },
                            })}
                        />
                    </FormGroup>
                    <div className='DurationDiv'>
                        <Label>Duration:</Label>
                        <input type="text" className="min" value={minDuration} placeholder="Min" onChange={(e) => { changeMinDuration(e) }} />
                        <span className='Dash'>-</span>
                        <input type="text" className={`max ${!maxDuration || (Number(maxDuration)>=Number(minDuration))? '' : 'error'}`} value={maxDuration} placeholder="Max" onChange={(e) => { changeMaxDuration(e) }} />
                    </div>
                    <div className="separator"></div>

                    <div className="mr-sm-2 searchDiv class-search ">
                        <input
                            value={searchText}
                            className="form-control mr-sm-2 class-search"
                            type="search"
                            placeholder=" Search Keyword"
                            aria-label="Search"
                            onChange={handleChangeSearch}
                        ></input>
                    </div>
                </div>
            </Toolbar>
            <Divider />
        </div>
    );
}

EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
};

const ProgramTable = (props) => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [order, setOrder] = useState(searchParams.get('order') || '');
    const [orderBy, setOrderBy] = useState(searchParams.get('order_by') || '');
    const [selected, setSelected] = useState([]);
    const [page, setPage] = useState(parseInt(searchParams.get('page')) || 1);
    const [rowsPerPage, setRowsPerPage] = useState(parseInt(searchParams.get('limit')) || 10);
    const [viewProgramsMainData, setViewProgramsMainData] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const navigate = useNavigate();
    const viewProgramsDat = useSelector(state => state?.viewPrograms);
    const viewProgramsDataRes = useSelector(state => state?.viewPrograms?.viewPrograms);
    const { permission, activeTab } = props;
    const dispatch = useDispatch();

    useEffect(()=>{
        if(!viewProgramsDat.loading)
            setShowLoader(false)
        if(!viewProgramsDat.loading && !viewProgramsDataRes?.data?.program_data && !viewProgramsDat.error){
            setShowLoader(true)
        }
    }, [viewProgramsDat.loading])

    useEffect(() => {
        if (activeTab == tabKeys.masterData.PROGRAMS) {
            const sendRequest = {
                "pageNo": searchParams.get('page') || 1,
                "pageSize": searchParams.get('limit') || 10,
                "filter_text": searchParams.get('filter_text') || '',
                "level": searchParams.get('level') || '',
                "min_duration": searchParams.get('min_duration') || '',
                "max_duration": searchParams.get('max_duration') || '',
            };
            dispatch(viewPrograms(sendRequest));
            dispatch(getAnandaProgamLevels())
        }else{
            setOrder(searchParams.get('order') || '');
            setOrderBy(searchParams.get('order_by') || '');
            setRowsPerPage(10)
        }
    }, [activeTab, searchParams]);
    
    useEffect(() => {
        if (viewProgramsDat.error !== "Ananda programs data does not exists") {
            viewProgramsDataRes && viewProgramsDataRes?.data?.program_data.map(val => {
                val.durationOne = parseInt(val.duration?.split(",")?.[0]);
            })
            setViewProgramsMainData(viewProgramsDataRes && viewProgramsDataRes?.data?.program_data);
        } else {
            setViewProgramsMainData('');
        }

    }, [viewProgramsDataRes, viewProgramsDat])



    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        const newOrder = isAsc ? 'desc' : 'asc';
        setOrder(newOrder);
        setOrderBy(property);
        const newParams = new URLSearchParams(searchParams);
        newParams.set('order', newOrder);
        newParams.set('orderBy', property);
        setSearchParams(newParams, { replace: true });
    };

    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelected = viewProgramsDataRes && viewProgramsMainData.map((n) => n.name);
            setSelected(newSelected);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };


    const handleChangePageNext = (newPage) => {
        const nextPage = viewProgramsDataRes?.data?.current_page_no + 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', nextPage);
        setSearchParams(newParams);
        setPage(nextPage);
        setShowLoader(true)
        const sendRequest = {
            "pageNo": nextPage,
            "pageSize": rowsPerPage,
            "filter_text": searchParams.get('filter_text') || '',
            "level": searchParams.get('level') || '',
            "min_duration": searchParams.get('min_duration') || '',
            "max_duration": searchParams.get('max_duration') || '',
        };
        dispatch(viewPrograms(sendRequest));
    };
    
    const handleChangePagePrev = (newPage) => {
        const prevPage = viewProgramsDataRes?.data?.current_page_no - 1;
        const newParams = new URLSearchParams(searchParams);
        newParams.set('page', prevPage);
        setSearchParams(newParams);
        setPage(prevPage);
        setShowLoader(true)
        const sendRequest = {
            "pageNo": prevPage,
            "pageSize": rowsPerPage,
            "filter_text": searchParams.get('filter_text') || '',
            "level": searchParams.get('level') || '',
            "min_duration": searchParams.get('min_duration') || '',
            "max_duration": searchParams.get('max_duration') || '',
        };
        dispatch(viewPrograms(sendRequest));
    };

    const handleChangeRowsPerPage = (event) => {
        const newParams = new URLSearchParams(searchParams);
        newParams.set('limit', event.value);
        newParams.set('page', 1);
        setSearchParams(newParams);

        setRowsPerPage(event.value);
        setPage(page);
        setShowLoader(true)
        const sendRequest = {
            "pageNo": 1,
            "pageSize": event.value,
            "filter_text": searchParams.get('filter_text') || '',
            "level": searchParams.get('level') || '',
            "min_duration": searchParams.get('min_duration') || '',
            "max_duration": searchParams.get('max_duration') || '',
        };
        dispatch(viewPrograms(sendRequest));
    };



    const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - viewProgramsDataRes && viewProgramsMainData?.length) : 0;


    const handleChangeViewPro = (selectedProgramId, data) => {
        if (data.status === 1) {
            navigate(routes.VIEW_PROGRAMS, { state: { selectedProgramId, permission } })
        }
    };

    const handleChangeOption = (e, id) => {
        if (permission === "write") {
            if (e.value === "Active") {
                viewProgramsMainData.find(v => v.program_id === id).status = 1;
            } else {
                viewProgramsMainData.find(v => v.program_id === id).status = 0;
            }
            setViewProgramsMainData(viewProgramsMainData)
            const sendRequest = {
                "feature_type": tabKeys.masterData.PROGRAMS,
                "id": id,
                "status": e.value === "Active" ? 1 : 0
            };
            dispatch(updateIsActiveStatus(sendRequest));
        } else {
            createNotification('warning', "Access Restricted");
        }
    }



    return (
      <Box sx={{ width: '100%' }} className="ProgramBox h-100">
        <Paper className='d-flex flex-column' sx={{ width: '100%', mb: 1, borderRadius: 2, height: 'calc(100% - 57px)' }}>
              <EnhancedTableToolbar numSelected={selected.length} pageNos={page}
                  activeTab={activeTab}
                  showLoader={showLoader}
                  setShowLoader={setShowLoader}
                  rowsPerPageNos={rowsPerPage} />
          {
              showLoader ?
              <div className='w-100 text-center py-5'>
                  <CircularProgress sx={{'color': '#74613C'}}/>
              </div>
              :
              <>
                  
                  {viewProgramsMainData && viewProgramsMainData.length > 0 ? 
                  <TableContainer sx={{ pt: 0, pr: 3, pb: 3, pl: 3, height: '100%' }}>
                      <Table
                          sx={{ minWidth: 750 }}
                          aria-labelledby="tableTitle"
                          stickyHeader
                          size='small'
                      >
                          <EnhancedTableHead
                              numSelected={selected.length}
                              order={order}
                              orderBy={orderBy}
                              onSelectAllClick={handleSelectAllClick}
                              onRequestSort={handleRequestSort}
                              rowCount={viewProgramsDataRes && viewProgramsMainData?.length}
                          />
                          <TableBody>
                              {
                                  viewProgramsDataRes && stableSort(viewProgramsMainData, getComparator(order, orderBy))
                                      .map((row, index) => {
                                          const labelId = `enhanced-table-checkbox-${index}`;
                                          return (
                                              <TableRow hover onClick={(event) => handleClick(event, row.title)} role="checkbox"

                                                  tabIndex={-1}
                                                  key={index}

                                              >
                                                  <TableCell component="th" id={labelId} scope="row" padding="none" sx={{ color: row.status == 1 ? '#000000' : "#AAAAAA" }}>{row.title}</TableCell>
                                                  <TableCell align="left" sx={{ color: row.status == 1 ? '#000000' : "#AAAAAA" }}>{row.level}</TableCell>
                                                  <TableCell align="left" sx={{ color: row.status == 1 ? '#000000' : "#AAAAAA" }}>{row.duration} Nights</TableCell>
                                                  <TableCell align="left" sx={{ color: row.status == 1 ? '#000000' : "#AAAAAA" }}>{row.usage}</TableCell>
                                                  <TableCell align="left" sx={{ color: row.status == 1 ? '#000000' : "#AAAAAA" }}>{row.created_on}</TableCell>
                                                  <TableCell align="left" width="10px" sx={{ color: row.status == 1 ? '#000000' : "#AAAAAA" }}

                                                  >
                                                      <Select

                                                          className="react-select status-select"
                                                          classNamePrefix="react-select"
                                                          onChange={(e) => { handleChangeOption(e, row.program_id) }}
                                                          value={row.status === 1 ? { label: "Active", value: "Active" } : { label: "Inactive", value: "Inactive" }}
                                                          options={options}
                                                          isSearchable={false}
                                                          menuPlacement="auto"
                                                            menuPosition="absolute"   
                                                            menuPortalTarget={null}
                                                          theme={(theme) => ({
                                                              ...theme,
                                                              isFocused: "#74613C",
                                                              colors: {
                                                                  ...theme.colors,
                                                                  primary25: '#F5F5F5',
                                                                  primary: '#f6f4f0',
                                                              },
                                                          })}
                                                          getOptionLabel={(row) => (
                                                              <><span className={row.label === "Active" ? "ActiveClass" : "InactiveClass"}
                                                              >
                                                                  {row.label}
                                                              </span>
                                                                  {row.status === 1 && (
                                                                      <div
                                                                      ></div>
                                                                  )}
                                                              </>
                                                          )}
                                                      />
                                                  </TableCell>
                                                  <TableCell align="left"
                                                      className={row.status == 1 ? ' ViewEditClick ' : "ViewEditNotClick"}
                                                      onClick={() => { handleChangeViewPro(row.program_id, row) }}><i className="fas fa-eye mr-2"></i>View</TableCell>
                                              </TableRow>
                                          );
                                      })}
                              {emptyRows > 0 && (
                                  <TableRow

                                  >
                                      <TableCell colSpan={6} />
                                  </TableRow>
                              )}
                          </TableBody>
                      </Table>
                  </TableContainer>
                  : 
                    <div className='w-100 text-center py-5'>
                      <p>No Records</p>
                    </div>
                    }
              </>
          }
          </Paper>
          {
              viewProgramsMainData
              &&
              <div className='paginationBlock'>
                  <div className='textData'><p>Items per page: </p></div>
                  <FormGroup className="FormGroup has-float-label rowsSelect class-menu-dropdown ">
                      <Select
                          placeholder={rowsPerPage}
                          className="react-select"
                          classNamePrefix="react-select"
                          value={rowsPerPage}
                          options={rowOptions}
                          isSearchable={false}
                          onChange={handleChangeRowsPerPage}
                          theme={(theme) => ({
                              ...theme,
                              colors: {
                                  ...theme.colors,
                                  primary25: '#F5F5F5',
                                  primary: '#74613C',
                              },
                          })}
                          menuPlacement="top"
                          menuPosition="fixed"
                          styles={{
                              menu: (base) => ({
                                  ...base,
                                  top: 'auto',
                                  bottom: 0,
                              }),
                          }}
                      />
                  </FormGroup>
                  {viewProgramsDataRes?.data && <p className='endText'>   {viewProgramsDataRes?.data?.start} - {viewProgramsDataRes?.data?.end} of {viewProgramsDataRes?.data?.total}</p>}
                  <p>                       
                    <button className={`btnPrev ${viewProgramsDataRes?.data?.current_page_no === 1 ? "opacityBtns" : ''}`} disabled={viewProgramsDataRes?.data?.current_page_no === 1} onClick={() => { handleChangePagePrev() }}>
                        <ArrowBackIosNewSharpIcon className='iconBtn' />
                    </button> 
                    <button className={`btnPrev ${viewProgramsDataRes?.data?.current_page_no === viewProgramsDataRes?.data?.total_pages ? "opacityBtns" : ''}`} disabled={viewProgramsDataRes?.data?.current_page_no === viewProgramsDataRes?.data?.total_pages} onClick={() => { handleChangePageNext() }}>
                        <ArrowForwardIosSharpIcon className='iconBtn' />
                    </button></p>
              </div>   
          }
      </Box>
    );
}
export default ProgramTable;